import { Outlet } from 'react-router-dom';
import Header from '../Header/Header';
import Sidebar, { SIDEBAR_WIDTH } from '../Sidebar/Sidebar';
import { useState } from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';

const HEADER_HEIGHT_PX = 60;
const CONTENT_TOP_OFFSET_PX = 8;

export default function LayoutWrapper() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const shouldPushContent = sidebarOpen && !isMobile;

  return (
    <Box
      sx={{
        width: '100%',
        height: '100dvh',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Header sidebarOpen={sidebarOpen} onSetSidebarOpen={setSidebarOpen} />
      <Sidebar open={sidebarOpen} setOpen={setSidebarOpen} isMobile={isMobile} />
      <Box
        sx={{
          position: 'absolute',
          top: `${HEADER_HEIGHT_PX + CONTENT_TOP_OFFSET_PX}px`,
          right: 0,
          bottom: 0,
          left: shouldPushContent ? `${SIDEBAR_WIDTH}px` : 0,
          width: 'auto',
          minHeight: 0,
          boxSizing: 'border-box',
          overflow: 'hidden',
          transition: 'left 200ms ease-in-out',
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}
